import React from 'react';
import { useNavigate } from 'react-router-dom';
import { IconPlus } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { useMantineTheme } from '@mantine/core';
import { ResponsiveButton } from './ResponsiveButton';

interface NewContentButtonProps {
  isMobile: boolean;
  isTablet: boolean;
}

export const NewContentButton: React.FC<NewContentButtonProps> = ({ isMobile, isTablet }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const theme = useMantineTheme();
  const isDark = theme.colors.dark != null;

  const handleNewContent = () => navigate('/new-content');

  return (
    <ResponsiveButton
      isMobile={isMobile}
      isTablet={isTablet}
      icon={<IconPlus size={isMobile ? 16 : isTablet ? 18 : 20} />}
      label={t('header.addContent')}
      variant={isDark ? 'light' : 'filled'}
      onClick={handleNewContent}
    />
  );
};
